module.exports = __webpack_public_path__ + "/img/CFP-Ab5ljl.svg";